import React from 'react'
import {useState} from 'react';
import styled from 'styled-components';
import {useBoundStore} from "../../stores/useBoundStore";
import Slider from '../atoms/Slider';

const Holder = styled.div``

const Ysliders = () => {

  const ySliders = ['a', 'b', 'c', 'd']

  const {yRows, setYRows} = useBoundStore(state => state);
  

  const [currentValues, setCurrentValues] = useState(
    yRows
  )

  function handleYrowsChange(index, newValue) {
    const remaining = 100 - newValue;

    // Calculate the new values for the other columns
    let newValues = currentValues.map((value, i) => {
      if (i === index) return parseInt(newValue);
      const oldRemaining = 100 - currentValues[index];
      let decimalValue = oldRemaining ? (remaining * value) / oldRemaining : remaining / (ySliders.length - 1);
      return Math.round(decimalValue);
    });

    // Find the difference between the sum of newValues and 100
    let diff = 100 - newValues.reduce((a, b) => a + b, 0);

    // If the active slider is reduced, reduce from the largest of the non-active numbers
    if (diff < 0) {
      let maxIndex = newValues.indexOf(Math.max(...newValues.filter((v, i) => i !== index)));
      newValues[maxIndex] += diff;
    } else {
      // Otherwise, add to the smallest of the non-active numbers
      let minIndex = newValues.indexOf(Math.min(...newValues.filter((v, i) => i !== index)));
      newValues[minIndex] += diff;
    }

    // Set the current values to the new values
    setCurrentValues(newValues);

    // Set the zustand state to match the new values
    setYRows(newValues);
  }

  return (
    <Holder>
      <p className="label">Rows</p>
      {ySliders.map((item, index) => (
        <Slider
          vertical={false}
          key={index}
          index={index}
          value={currentValues[index]}
          title={item}
          onChange={(e) => handleYrowsChange(index, e.target.value)}
        />
      ))}
    </Holder>
  )
}

export default Ysliders